module.exports = __webpack_public_path__ + "static/media/warning_sign.3f92e3ed.png";